module.exports = __webpack_public_path__ + "static/media/tks.e9f6530a.png";